import { render, staticRenderFns } from "./multi-reftable-item-selector.vue?vue&type=template&id=47f1ea28&lang=pug&"
import script from "./multi-reftable-item-selector.vue?vue&type=script&lang=ts&"
export * from "./multi-reftable-item-selector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports